/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompassDeviceAnalytics
 */
export interface CompassDeviceAnalytics {
    /**
     * 
     * @type {string}
     * @memberof CompassDeviceAnalytics
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof CompassDeviceAnalytics
     */
    device_type: string;
    /**
     * 
     * @type {number}
     * @memberof CompassDeviceAnalytics
     */
    count: number;
}

/**
 * Check if a given object implements the CompassDeviceAnalytics interface.
 */
export function instanceOfCompassDeviceAnalytics(value: object): value is CompassDeviceAnalytics {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('device_type' in value) || value['device_type'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function CompassDeviceAnalyticsFromJSON(json: any): CompassDeviceAnalytics {
    return CompassDeviceAnalyticsFromJSONTyped(json, false);
}

export function CompassDeviceAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompassDeviceAnalytics {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['orgCode'],
        'device_type': json['deviceType'],
        'count': json['count'],
    };
}

export function CompassDeviceAnalyticsToJSON(json: any): CompassDeviceAnalytics {
    return CompassDeviceAnalyticsToJSONTyped(json, false);
}

export function CompassDeviceAnalyticsToJSONTyped(value?: CompassDeviceAnalytics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orgCode': value['org_code'],
        'deviceType': value['device_type'],
        'count': value['count'],
    };
}

